<div class="toggle-visible" [style.display]="appIsHidden ? 'none' : 'block'">
    <ng-container *ngIf="{ value: state$ | async } as stateWrapper">
        <ng-container *ngIf="stateWrapper.value as state">
            <div
                [class.container-wrapper]="viewportScaling.enabled"
                [class.supervisor-mode]="supervisorMode"
                [class.online-mode]="state.configuration.tableMode === TableMode.Online"
            >
                <div
                    class="container"
                    #container
                    (window:resize)="scaleContainer($event)"
                    [style.width]="containerWidth"
                    [style.height]="containerHeight"
                >
                    <header>
                        <div class="header-content">
                            <button
                                class="icon icon-menu"
                                [class.icon-menu-active]="menuVisible"
                                (click)="menuVisible = !menuVisible"
                            ></button>

                            <div class="title">
                                <div class="text-large" i18n>{{ state.configuration.gameType | gameLabel }}</div>
                                <div class="text-medium">
                                    <ng-container i18n>Connected players</ng-container>: {{ state.playerCount || 0 }} /
                                    <ng-container i18n>Game ID</ng-container>:
                                    {{ state.roundState.roundId ?? '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="header-content">
                            <div class="title title-align-right">
                                <div class="text-large">
                                    {{ state.croupier?.name ?? '-' }}
                                </div>
                                <div class="text-medium">{{ time$ | async }}</div>
                            </div>
                            <button *ngIf="state.croupier?.name" class="icon icon-logout"></button>
                        </div>
                    </header>
                    <div class="body">
                        <div *ngIf="menuVisible" (click)="menuVisible = false" class="menu-container">
                            <div class="menu">
                                <div class="layer layer-menu">
                                    <ul>
                                        <li>
                                            <button
                                                [disabled]="state.roundState.phase !== AppPhase.WaitingForCroupier"
                                                i18n
                                                (click)="menuVisible = false; selectGameVisible = true"
                                            >
                                                Select game
                                            </button>
                                        </li>
                                        <li>
                                            <button i18n (click)="menuVisible = false; aboutDialogVisible = true">About game</button>
                                        </li>

                                        @if (languages.length > 0) {
                                            <li i18n class="label">Languages</li>
                                            @for (language of languages; track language.code) {
                                                <li>
                                                    <button class="no-left-bg" (click)="changeLanguage(language.code)">
                                                        <span class="unicode-icon">{{ language.flagSymbol }}</span
                                                        ><span i18n>{{ language.label }} </span>
                                                    </button>
                                                </li>
                                            }
                                        }
                                    </ul>
                                </div>

                                <div class="layer layer-overlay"></div>
                            </div>
                        </div>

                        <div
                            class="main-area"
                            [class.main-area-when-sidebar-open]="
                                state.configuration.tableMode === TableMode.Online && state.roundState.phase !== AppPhase.WaitingForCroupier
                            "
                        >
                            <main>
                                <app-modal *ngIf="aboutDialogVisible" (closeClicked)="aboutDialogVisible = false">
                                    <app-about [backendVersion]="state.configuration.appVersion" [frontendVersion]="version"></app-about>
                                </app-modal>
                                <app-game-selection
                                    *ngIf="selectGameVisible"
                                    [games]="state.games"
                                    [currentGame]="state.configuration.gameType"
                                    (gameSelected)="onGameSelect($event)"
                                    (closeClicked)="selectGameVisible = false"
                                ></app-game-selection>
                                <app-error-panel
                                    *ngIf="state.roundState?.phase === AppPhase.RoundError"
                                    [errorCode]="state.roundState.errorCode"
                                ></app-error-panel>
                                <app-closed-table *ngIf="state.roundState?.phase === AppPhase.WaitingForCroupier"></app-closed-table>
                                <app-waiting-for-players
                                    *ngIf="state.roundState?.phase === AppPhase.WaitingForPlayers"
                                ></app-waiting-for-players>
                                <app-round-voided *ngIf="state.roundState?.phase === AppPhase.RoundVoid"></app-round-voided>
                                <app-shoe-change *ngIf="state.roundState?.phase === AppPhase.ShoeChange"></app-shoe-change>
                                <app-burn-cards
                                    *ngIf="state.roundState?.phase === AppPhase.CardBurn"
                                    [card]="state.shoeChangeState?.card"
                                    [totalToBurnCount]="state.shoeChangeState?.totalToBurnCount ?? 0"
                                    [burnedCardsCount]="state.shoeChangeState?.burnedCount || 0"
                                ></app-burn-cards>
                                <app-new-round-preparation
                                    *ngIf="state.roundState?.phase === AppPhase.NewRoundPreparation"
                                ></app-new-round-preparation>
                                <app-bets-are-open
                                    *ngIf="state?.roundState?.phase === AppPhase.BetsOpen"
                                    i18n
                                    [initialTimeInSeconds]="
                                        state.roundState.remainingBettingTimeInSeconds ?? state.configuration.bettingWindowInSeconds
                                    "
                                    >Bets are open
                                </app-bets-are-open>
                                <app-bets-are-open
                                    *ngIf="state?.roundState?.phase === AppPhase.BetsClosed"
                                    i18n
                                    [animate]="false"
                                    [initialTimeInSeconds]="0"
                                    >Bets are closed
                                </app-bets-are-open>
                                <app-game-switch
                                    [gameType]="state.configuration.gameType"
                                    [tableUpdate]="state.tableUpdate"
                                    [appPhase]="state.roundState.phase"
                                    [subPhase]="state.roundState.subPhase"
                                >
                                    <app-count-down
                                        *ngIf="state?.roundState?.phase === AppPhase.Decision"
                                        [initialTimeInSeconds]="state.configuration.decisionTimeInSeconds ?? 0"
                                        [animate]="true"
                                    ></app-count-down>
                                </app-game-switch>

                                @if (state.roundState.phase === AppPhase.DealingCards || state.roundState.phase === AppPhase.RoundEnd) {
                                    <app-cut-card *ngIf="state.shoeChangeState?.cutCardDrawn"></app-cut-card>
                                }
                            </main>

                            <footer
                                *ngIf="
                                    state.roundState?.phase !== AppPhase.WaitingForCroupier &&
                                    state.roundState?.phase !== AppPhase.WaitingForPlayers &&
                                    state.roundState?.phase !== AppPhase.RoundVoid
                                "
                            >
                                <div class="buttons-container">
                                    <div class="button-group">
                                        <button
                                            *ngIf="state.roundState.phase !== AppPhase.WaitingForCroupier"
                                            i18n
                                            class="button-game button-game-small"
                                            [class.button-game-highlight]="state.flagsState.roundFlagged"
                                            [disabled]="state.flagsState.roundFlagged"
                                            (click)="onFlagGameClick(flagGameButton)"
                                            #flagGameButton
                                        >
                                            @if (state.flagsState.roundFlagged) {
                                                Game flagged
                                            } @else {
                                                Flag game
                                            }
                                        </button>
                                        <button
                                            *ngIf="
                                                state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                                (state.roundState.phase === AppPhase.BetsOpen ||
                                                    state.roundState.phase === AppPhase.BetsClosed ||
                                                    state.roundState.phase === AppPhase.DealingCards)
                                            "
                                            i18n
                                            class="button-game button-game-medium"
                                            (click)="onVoidClick(voidButton)"
                                            #voidButton
                                        >
                                            Void game and change shoe
                                        </button>
                                    </div>
                                    <button
                                        *ngIf="state.roundState?.phase === AppPhase.ShoeChange"
                                        i18n
                                        class="button-game button-game-large"
                                        (click)="onShoeChangedClick(shoeChangedButton)"
                                        appAutofocus
                                        #shoeChangedButton
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        *ngIf="
                                            state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                            state.roundState.phase !== AppPhase.CardBurn
                                        "
                                        i18n
                                        class="button-game button-game-small"
                                        [class.button-game-highlight]="state.flagsState.tableClosingRequested"
                                        [disabled]="state.flagsState.tableClosingRequested"
                                        (click)="onCloseTableClick(closeTableButton)"
                                        #closeTableButton
                                    >
                                        @if (state.flagsState.tableClosingRequested) {
                                            Closing table
                                        } @else {
                                            Close table
                                        }
                                    </button>
                                </div>
                                <app-notification
                                    *ngIf="notification.show"
                                    [text]="notification.text"
                                    [severity]="notification.severity"
                                    [canClose]="notification.canClose"
                                    (closeClicked)="hideNotification()"
                                ></app-notification>
                            </footer>
                        </div>
                        <div
                            class="sidebar"
                            *ngIf="
                                state.configuration.tableMode === TableMode.Online && state.roundState.phase !== AppPhase.WaitingForCroupier
                            "
                        >
                            <app-streaming-video
                                [videoEnabled]="!isVideoHidden"
                                [streamId]="state.configuration.videoStreamId"
                                (toggleClicked)="isVideoHidden = !isVideoHidden"
                            ></app-streaming-video>

                            <app-chat
                                [chatEnabled]="state.flagsState.chatEnabled"
                                [messages]="state.chatMessages"
                                (toggleClicked)="state.flagsState.chatEnabled ? onDisableChatClick($event) : onEnableChatClick($event)"
                            ></app-chat>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div *ngIf="!stateWrapper.value" class="container">
            <h2 i18n class="title-vertical-center title-white">Connecting to table…</h2>
        </div>
    </ng-container>
</div>
